import styled from 'styled-components'
import { Button as BoltButton } from '@sainsburys-tech/bolt'

const Heading = styled.h2`
  font-size: ${props => props.theme.font.size['label-2']};
  font-weight: ${props => props.theme.font.weight.bold};
`
const Message = styled.p`
  margin: ${props => props.theme.size.spacing.lg} 0;
  min-height: 100%;
`
const Wrapper = styled.div`
  margin: ${props => props.theme.size.spacing['2xl']} 0;
`
const Button = styled(BoltButton)`
  && {
    margin-top: ${props => props.theme.size.spacing.xl};
    @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
      width: 265px;
    }
  }
`

export { Heading, Message, Wrapper, Button }
